import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useReportContext } from "../../../../../_context/ReportContext";
import { ClientType } from "../../../../../_models/Client.model";

const ReportNDISQuestions: React.FC = () => {
  const { currentViewingReport } = useReportContext();

  // Only show for NDIS reports
  if (currentViewingReport.Client.Type !== ClientType.NDIS) {
    return null;
  }

  return (
    <Container className="mt-4">
      <Row>
        <Col>
          <div className="mb-4">
            <h3 className="reportAreaName">
              <strong>Did any incidents occur during the cleaning?</strong>
            </h3>
            <div className="mt-2">
              <span className={`badge ${currentViewingReport.NDISIncidentOccurred ? 'bg-danger' : 'bg-success'}`}>
                {currentViewingReport.NDISIncidentOccurred ? 'Yes' : 'No'}
              </span>
            </div>
            
            {/* Show incident details if incidents occurred */}
            {currentViewingReport.NDISIncidentOccurred && currentViewingReport.NDISIncidentDetails && (
              <div className="mt-3">
                <strong>Incident Details:</strong>
                <div className="mt-2 p-3 bg-light border rounded">
                  {currentViewingReport.NDISIncidentDetails}
                </div>
              </div>
            )}
          </div>
          
          <div className="mb-4">
            <h3 className="reportAreaName">
              <strong>Required PPE was used by the staff member during the session</strong>
            </h3>
            <div className="mt-2">
              <span className={`badge ${currentViewingReport.NDISPPEUsed ? 'bg-success' : 'bg-warning'}`}>
                {currentViewingReport.NDISPPEUsed ? 'Yes' : 'No'}
              </span>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default ReportNDISQuestions; 